import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getImageUrl } from "src/Common/common";
import UserService from "src/Services/API/user.service";

function SideMenu() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = UserService.getCurrentUser();
  const isSuperAdmin = currentUser?.roles?.[0]?.name === "Super Admin";
  const mainHighlightColor = "bg-menuHighlightColor";
  const bottomHighlightColor = "bg-[#E6E7EC]";
  const [formsExpanded, setFormsExpanded] = useState(false);
  const getBgColorArray = (activeIndex) => {
    const colors = Array(8).fill("bg-transparent");
    if (activeIndex >= 0) {
      const isBottomItem = activeIndex >= 6;
      colors[activeIndex] = isBottomItem ? bottomHighlightColor : mainHighlightColor;
    }
    return colors;
  };

  const [bgColorArray, setBgColorArray] = useState(getBgColorArray(-1));
  const getTextColorClass = (index) => {
    return bgColorArray[index] === "bg-transparent" ? "text-[#80869E]" : "text-[#404A6E]";
  };
  const getHoverClass = (index) => {
    return bgColorArray[index] === "bg-transparent" ? "hover:bg-[#E6F2FF]" : "";
  };

  useEffect(() => {
    if (location.pathname.includes("/work")) {
      setBgColorArray(getBgColorArray(0));
    } else if (location.pathname.includes("/purchase")) {
      setBgColorArray(getBgColorArray(1));
    } else if (location.pathname.includes("/recommendations")) {
      setBgColorArray(getBgColorArray(2));
    } else if (location.pathname.includes("/customer")) {
      setBgColorArray(getBgColorArray(3));
    } else if (location.pathname.includes("/calendar")) {
      setBgColorArray(getBgColorArray(4));
    } else if (location.pathname.includes("/form-templates") || location.pathname.includes("/all-forms")) {
      setBgColorArray(getBgColorArray(-1));
      setFormsExpanded(true);
    } else if (location.pathname.includes("/userguides")) {
      setBgColorArray(getBgColorArray(6));
    } else if (location.pathname.includes("/ticket")) {
      setBgColorArray(getBgColorArray(7));
    } else {
      setBgColorArray(getBgColorArray(-1));
    }
  }, [location.pathname]);

  const workOrderClicked = () => {
    if (!location.pathname.includes("/work")) {
      navigate("/work");
      setBgColorArray(getBgColorArray(0));
    }
  };

  const purchaseOrderClicked = () => {
    if (!location.pathname.includes("/purchase")) {
      navigate("/purchase");
      setBgColorArray(getBgColorArray(1));
    }
  };

  const recommendationsClicked = () => {
    navigate("/recommendations");
    setBgColorArray(getBgColorArray(2));
  };

  const customerClicked = () => {
    navigate("/customer");
    setBgColorArray(getBgColorArray(3));
  };

  const calendarClicked = () => {
    navigate("/calendar");
    setBgColorArray(getBgColorArray(4));
  };

  const formsToggle = () => {
    setFormsExpanded((prev) => !prev);
  };

  const templatesClicked = () => {
    navigate("/form-templates");
    setBgColorArray(getBgColorArray(-1));
  };

  const allFormsClicked = () => {
    navigate("/all-forms");
    setBgColorArray(getBgColorArray(-1));
  };

  const userGuidesClicked = () => {
    navigate("/userguides");
    setBgColorArray(getBgColorArray(6));
  };

  const ticketClicked = () => {
    navigate("/ticket");
    setBgColorArray(getBgColorArray(7));
  };

  return (
    <div className="w-[257px] h-screen fixed top-0 left-0 bg-backgroundColor border-r-[1px] border-borderColor overflow-y-auto flex flex-col">
      <div className="w-full h-[80px] flex items-center px-[30px] mt-7">
        <img className="aspect-auto w-[190px]" src={getImageUrl("/images/logos/Black logo - no background.png")} />
      </div>

      <div className="w-full flex flex-1 pl-5 pr-1 flex-col mt-5 gap-1">
        <div
          className={`flex items-center h-[24px]  gap-2 cursor-pointer px-1 rounded-md ${getHoverClass(0)} ${bgColorArray[0]}`}
          onClick={workOrderClicked}
        >
          <img className="aspect-auto w-[18px]" src={getImageUrl("/images/sidemenu/workorder.png")} />
          <div className={`text-inputEmailTitle text-[12px] font-OpenSansRegular font-[600] ${getTextColorClass(0)}`}>
            Work Orders
          </div>
        </div>

        <div
          className={`flex items-center h-[24px] gap-2 cursor-pointer px-1 rounded-md ${getHoverClass(1)} ${bgColorArray[1]}`}
          onClick={purchaseOrderClicked}
        >
          <img className="aspect-auto w-[18px]" src={getImageUrl("/images/sidemenu/purchaseorder.png")} />
          <div className={`text-inputEmailTitle text-[12px] font-OpenSansRegular font-[600] ${getTextColorClass(1)}`}>
            Purchase Orders
          </div>
        </div>

        <div
          className={`flex items-center h-[24px] gap-2 cursor-pointer px-1 rounded-md ${getHoverClass(2)} ${bgColorArray[2]}`}
          onClick={recommendationsClicked}
        >
          <img className="aspect-auto w-[18px]" src={getImageUrl("/images/sidemenu/recommendations.png")} />
          <div className={`text-inputEmailTitle text-[12px] font-OpenSansRegular font-[600] ${getTextColorClass(2)}`}>
            Recommendations
          </div>
        </div>

        <div
          className={`flex items-center h-[24px] gap-2 cursor-pointer px-1 rounded-md ${getHoverClass(3)} ${bgColorArray[3]}`}
          onClick={customerClicked}
        >
          <img className="aspect-auto w-[18px]" src={getImageUrl("/images/sidemenu/black_customer.png")} />
          <div className={`text-inputEmailTitle text-[12px] font-OpenSansRegular font-[600] ${getTextColorClass(3)}`}>
            Customers
          </div>
        </div>
        <div
          className={`flex items-center h-[24px] gap-2 cursor-pointer px-1 rounded-md ${getHoverClass(4)} ${bgColorArray[4]}`}
          onClick={calendarClicked}
        >
          <img className="aspect-auto w-[18px]" src={getImageUrl("/images/sidemenu/date.png")} />
          <div className={`text-inputEmailTitle text-[12px] font-OpenSansRegular font-[600] ${getTextColorClass(4)}`}>
            Calendar
          </div>
        </div>

        <div>
          <div
            className="flex items-center h-[24px] gap-2 cursor-pointer px-1 rounded-md bg-transparent hover:bg-[#E6F2FF]"
            onClick={formsToggle}
          >
            <img className="aspect-auto w-[18px]" src={getImageUrl("/images/sidemenu/lists.png")} />
            <div className="text-inputEmailTitle text-[12px] font-OpenSansRegular font-[600] flex-1 text-[#80869E]">
              Forms
            </div>
            <svg
              className={`w-[14px] h-[14px] transition-transform ${formsExpanded ? "" : "rotate-180"}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="#80869E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="18 15 12 9 6 15" />
            </svg>
          </div>
          {formsExpanded && (
            <div className="flex flex-col gap-1 mt-1 ml-[26px]">
              <div
                className={`flex items-center h-[24px] cursor-pointer px-2 rounded-md ${location.pathname.includes("/form-templates") ? mainHighlightColor : "bg-transparent hover:bg-[#E6F2FF]"}`}
                onClick={templatesClicked}
              >
                <div className={`text-inputEmailTitle text-[12px] font-OpenSansRegular font-[600] ${location.pathname.includes("/form-templates") ? "text-[#404A6E]" : "text-[#80869E]"}`}>
                  Templates
                </div>
              </div>
              <div
                className={`flex items-center h-[24px] cursor-pointer px-2 rounded-md ${location.pathname.includes("/all-forms") ? mainHighlightColor : "bg-transparent hover:bg-[#E6F2FF]"}`}
                onClick={allFormsClicked}
              >
                <div className={`text-inputEmailTitle text-[12px] font-OpenSansRegular font-[600] ${location.pathname.includes("/all-forms") ? "text-[#404A6E]" : "text-[#80869E]"}`}>
                  All Forms
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="w-full flex flex-col pl-5 pr-1 pb-6 gap-1 mt-auto">
        {/* <div
          className={`flex items-center h-[24px] gap-2 cursor-pointer px-1 rounded-md ${bgColorArray[5]}`}
          onClick={userGuidesClicked}
        >
          <img className="aspect-auto w-[18px]" src={getImageUrl("/images/sidemenu/help/video.png")} />
          <div className={`text-inputEmailTitle text-[12px] font-OpenSansRegular font-[600] ${getTextColorClass(6)}`}>
            User Guides
          </div>
        </div> */}
        <div
          className={`flex items-center h-[24px] gap-2 cursor-pointer px-1 rounded-md ${getHoverClass(7)} ${bgColorArray[7]}`}
          onClick={ticketClicked}
        >
          <img className="aspect-auto w-[18px]" src={getImageUrl("/images/sidemenu/help/info.png")} />
          <div className={`text-inputEmailTitle text-[12px] font-OpenSansRegular font-[600] ${getTextColorClass(7)}`}>
            {isSuperAdmin ? "Ticket Management" : "Report Bug"}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideMenu;
